// extracted by mini-css-extract-plugin
export default {"srOnly":"_0cB08","submit":"-FNu2","verification":"_4-fzS","dash":"GzvBB"};